import { X } from 'lucide-react'
import { FilterChipProps } from '../types'

const CHIP_STYLE = { backgroundColor: '#F5F5F5' }

export function FilterChip({ name, onRemove }: FilterChipProps) {
  return (
    <div
      className="flex items-center gap-1 rounded-full px-3 py-1 flex-shrink-0"
      style={CHIP_STYLE}
    >
      <span className="text-xs font-semibold text-gray-900">{name}</span>
      <button
        type="button"
        onClick={onRemove}
        className="text-gray-500 hover:text-gray-700"
        aria-label="Remover filtro"
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  )
}
